var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/wrench/components/navigation/TeamMenu/TeamMenu.tsx",
  _this = this;
import React, { useContext, useMemo } from 'react';
import { defineMessages, T, t } from '@sm/intl';
import { Accordion } from '@wds/accordion';
import { Box } from '@wds/box';
import { IconCaretDown } from '@wds/icons';
import { List } from '@wds/list';
import { Menu } from '@wds/menu';
import { Responsive } from '@wds/responsive';
import { generateMetricsAttribute, MetricsTracker, USER_EVENTS } from '@sm/metrics';
import { NavButton } from '../../nav-button';
import { SubMenuItem } from '../../mobile-nav/SubMenuItem';
import getMyTeamMenuItems from '../../../../../../helpers/TeamMenuHelpers';
import HeaderContext from '../../../HeaderContext';
import { useAuthQuery } from './team-menu.generated';
import { RbacPermissionType } from '../../../../../../types';
var COPY = defineMessages({
  MY_TEAM: {
    id: 'TeamMenu.myTeam',
    defaultMessage: 'My Team',
    description: '[Type: Label][Vis.: low] - My team section of nav bar'
  }
});
var TeamMenu = function TeamMenu() {
  var _permissionData$RbacP, _permissionData$RbacP2, _permissionData$RbacP3, _permissionData$RbacP4, _permissionData$RbacP5, _permissionData$RbacP6, _permissionData$RbacP7, _permissionData$RbacP8, _permissionData$RbacP9, _permissionData$RbacP10, _permissionData$RbacP11, _permissionData$RbacP12, _user$teamMembership;
  var _useContext = useContext(HeaderContext),
    session = _useContext.session,
    pageURL = _useContext.pageURL,
    pageName = _useContext.pageName;
  var _useAuthQuery = useAuthQuery({
      fetchPolicy: 'network-only',
      variables: {
        permissions: [RbacPermissionType.TeamSummaryView, RbacPermissionType.UsersView, RbacPermissionType.UsersInvite, RbacPermissionType.DivisionsView, RbacPermissionType.WorkgroupsView, RbacPermissionType.ActivityView, RbacPermissionType.OfflineDevicesManage, RbacPermissionType.AudienceCreditsManage, RbacPermissionType.AudienceCreditsManageCreditPools, RbacPermissionType.AdminDashboardView, RbacPermissionType.AdminReportingView, RbacPermissionType.LibraryView]
      }
    }),
    loading = _useAuthQuery.loading,
    data = _useAuthQuery.data;
  var permissionData = useMemo(function () {
    return (data === null || data === void 0 ? void 0 : data.rbacPermissions.reduce(function (acc, value) {
      acc[value.permission] = value.isAuthorized;
      return acc;
    }, {})) || {};
  }, [data]);
  var hasUserReportPermissions = (_permissionData$RbacP = permissionData[RbacPermissionType.AdminReportingView]) !== null && _permissionData$RbacP !== void 0 ? _permissionData$RbacP : false;
  var hasAdminDashboardPermissions = (_permissionData$RbacP2 = permissionData[RbacPermissionType.AdminDashboardView]) !== null && _permissionData$RbacP2 !== void 0 ? _permissionData$RbacP2 : false;
  var permissions = {
    teamSummary: (_permissionData$RbacP3 = permissionData[RbacPermissionType.TeamSummaryView]) !== null && _permissionData$RbacP3 !== void 0 ? _permissionData$RbacP3 : false,
    manageUsers: (_permissionData$RbacP4 = permissionData[RbacPermissionType.UsersView]) !== null && _permissionData$RbacP4 !== void 0 ? _permissionData$RbacP4 : false,
    addUsers: (_permissionData$RbacP5 = permissionData[RbacPermissionType.UsersInvite]) !== null && _permissionData$RbacP5 !== void 0 ? _permissionData$RbacP5 : false,
    division: (_permissionData$RbacP6 = permissionData[RbacPermissionType.DivisionsView]) !== null && _permissionData$RbacP6 !== void 0 ? _permissionData$RbacP6 : false,
    workgroup: (_permissionData$RbacP7 = permissionData[RbacPermissionType.WorkgroupsView]) !== null && _permissionData$RbacP7 !== void 0 ? _permissionData$RbacP7 : false,
    activity: (_permissionData$RbacP8 = permissionData[RbacPermissionType.ActivityView]) !== null && _permissionData$RbacP8 !== void 0 ? _permissionData$RbacP8 : false,
    library: (_permissionData$RbacP9 = permissionData[RbacPermissionType.LibraryView]) !== null && _permissionData$RbacP9 !== void 0 ? _permissionData$RbacP9 : false,
    offlineDevices: (_permissionData$RbacP10 = permissionData[RbacPermissionType.OfflineDevicesManage]) !== null && _permissionData$RbacP10 !== void 0 ? _permissionData$RbacP10 : false,
    adminDashboard: hasAdminDashboardPermissions && !hasUserReportPermissions,
    userReport: hasUserReportPermissions,
    audienceCreditsManage: (_permissionData$RbacP11 = permissionData[RbacPermissionType.AudienceCreditsManage]) !== null && _permissionData$RbacP11 !== void 0 ? _permissionData$RbacP11 : false,
    audienceCreditsManageCreditPools: (_permissionData$RbacP12 = permissionData[RbacPermissionType.AudienceCreditsManageCreditPools]) !== null && _permissionData$RbacP12 !== void 0 ? _permissionData$RbacP12 : false
  };
  if (loading) return null;
  if (!(data !== null && data !== void 0 && data.user)) return null;
  var user = data === null || data === void 0 ? void 0 : data.user;
  var TrackMenuEvents = function TrackMenuEvents(opened) {
    MetricsTracker.track({
      name: USER_EVENTS.ELEMENT_INTERACTION,
      data: {
        url: pageURL,
        pageName: pageName,
        amplitudeEvent: 'header clicked menu',
        menuName: 'team',
        opened: opened
      }
    });
  };
  var GenerateMetricsNavigationEvent = function GenerateMetricsNavigationEvent(navItem) {
    return generateMetricsAttribute({
      data: {
        url: pageURL,
        pageName: pageName,
        amplitudeEvent: 'header clicked navigation',
        navItem: navItem
      }
    });
  };
  var teamMembership = (_user$teamMembership = user.teamMembership) !== null && _user$teamMembership !== void 0 ? _user$teamMembership : {
    isAdmin: false,
    isEnterprise: false,
    memberType: ''
  };
  var canSeeTeamTab = teamMembership.isAdmin || teamMembership.isEnterprise;
  var title = t(COPY.MY_TEAM);
  var menuItems = getMyTeamMenuItems({
    user: user,
    session: session,
    permissions: permissions
  });
  return canSeeTeamTab ? /*#__PURE__*/React.createElement(Responsive, {
    minWidth: "xl",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 127,
      columnNumber: 5
    }
  }, function (matches) {
    return matches ? /*#__PURE__*/React.createElement(Menu, {
      placement: "bottom-left",
      noRules: true,
      dense: true,
      menuTrigger: /*#__PURE__*/React.createElement(NavButton, {
        label: "Open My Team menu",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 135,
          columnNumber: 15
        }
      }, /*#__PURE__*/React.createElement(T, {
        desc: COPY.MY_TEAM,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 136,
          columnNumber: 17
        }
      }), /*#__PURE__*/React.createElement(Box, {
        ml: 2,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 137,
          columnNumber: 17
        }
      }, /*#__PURE__*/React.createElement(IconCaretDown, {
        title: "Dropdown arrow",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 138,
          columnNumber: 19
        }
      }))),
      key: title,
      elevation: 10000,
      onChange: function onChange(showMenu) {
        TrackMenuEvents(showMenu);
      },
      alwaysRenderContent: true,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 130,
        columnNumber: 11
      }
    }, menuItems.map(function (item) {
      return /*#__PURE__*/React.createElement(Menu.Item, {
        key: "".concat(item.name, "-teamMenu"),
        navigationTarget: item.path,
        isNavigable: true,
        "data-sm-metrics": GenerateMetricsNavigationEvent(item.navItem),
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 151,
          columnNumber: 17
        }
      }, item.name);
    })) : /*#__PURE__*/React.createElement(Accordion, {
      key: "accordion-MyTeam",
      onChange: function onChange(e) {
        return TrackMenuEvents(!e.length);
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 163,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Accordion.Item, {
      title: title,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 167,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(List, {
      transparent: true,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 168,
        columnNumber: 15
      }
    }, menuItems.map(function (item) {
      return /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({
        key: item.name,
        metrics: GenerateMetricsNavigationEvent(item.navItem)
      }, item, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 171,
          columnNumber: 21
        }
      }));
    }))));
  }) : null;
};
export default TeamMenu;
export { TeamMenu };
//# sourceMappingURL=TeamMenu.js.map